import React from 'react';
import uuid from 'uuid-random';
import { LessonType, StyledTypeLink, StyledEmptyBlock } from '../../../../components/Styled/StyledWrappers';
import { COLORS } from '../../../../constants';
import { Collection } from '../../../../types';
import { getLabelBgColor, getLabelLetterIcon } from '../../../../utils';
import { LockIcon } from 'react-magma-icons';

interface ILessonCollection {
  collection: Collection;
  isAccessible: boolean;
}

export const LessonCollection = (props: ILessonCollection): JSX.Element => {
  const {
    collection: { title, collectionId },
    isAccessible,
  } = props;

  const Letter = getLabelLetterIcon(title);

  const lessonTypeTestId = title.toLocaleLowerCase().replace(/ /g, '-');

  const lockIconColor = title.slice(-1) === 'A' ? COLORS.white : COLORS.black;

  const linkTo = isAccessible ? `collection/${collectionId}` : '/accesscode';

  return (
    <StyledTypeLink tabIndex={0} aria-label={title} to={linkTo} key={uuid()}>
      <LessonType
        tabIndex={-1}
        key={collectionId}
        color={getLabelBgColor(title)}
        isAccessible={isAccessible}
        data-testid={lessonTypeTestId}
      >
        {!isAccessible && <StyledEmptyBlock />}
        <Letter />
        {!isAccessible && <LockIcon color={lockIconColor} />}
      </LessonType>
    </StyledTypeLink>
  );
};
